module.exports = __webpack_public_path__ + "img/Mb_Lobby_Video.05165e73.jpg";